import React from 'react';


const Footer = () => {
  return (
    <footer className="main-footer d-flex justify-content-center align-items-center footer-container text-white">
      {/* <strong className="mb-0">
        Copyright © {new Date().getFullYear()}{' '}
        <a href="http://www.oneitonline.com" className='text-white'>ONE IT Solutions</a>.
      </strong>
      <div className="ms-3 ">
        <b className='text-end'>Version</b> 1.0.0
      </div> */}
      <p className='text-white'> &copy; {new Date().getFullYear()} Technical Paper Submission. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
